import { InvoiceProductWithScalePrice } from '../../features/invoices/models/invoice-product-scale-price';

export const getProductPrice = (
    value: number,
    currency: string,
    quantity: number,
    product?: InvoiceProductWithScalePrice
): number => {
    if (product) {
        // A price of 0 is the placeholder of an article without scale prices,
        // not a price: it turned 1.000 m at 4,70 € into 0 € when the quantity
        // changed (R-227). The copy keeps the article's own list in order.
        const specialPrice = product.currentSpecialPrice?.[currency];
        const scalePrice = [...(product.prices ?? [])]
            .filter(x => x.price > 0)
            .sort((a, b) => b.quantity - a.quantity)
            .find(x => quantity >= x.quantity);
        const candidates = [specialPrice, scalePrice?.price].filter(
            (price): price is number => typeof price === 'number' && price > 0
        );

        if (candidates.length > 0) {
            return Math.min(...candidates);
        }
    }
    return value;
};
